type DoubleCheckmarkIconProps = {
  color: string;
};

export const DoubleCheckmarkIcon = ({ color }: DoubleCheckmarkIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path d="M0 0h16v16H0z" fill="none" />
    <path
      data-name="Shape"
      d="M8.009 8.014 3.766 3.771l.943-.942 1.417 1.416.941.941.941.941L13.653.484l.943.943L8.01 8.013zm-3.766 0L0 3.771l.942-.943.942.942 3.3 3.3-.942.942zm3.766-3.772-.94-.942 3.3-3.3.94.94-3.3 3.3z"
      transform="translate(.667 3.986)"
      fill={color}
    />
  </svg>
);
